import { Add } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useRef, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import EventEditModal from "@/shared/sharedService/EventEditModal";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import ManyToOneSelect from "@/shared/forms/ManyToOneSelect";
import { usePersistantStore } from "@/stores/global";
import ApiService from "@/api/ApiService";
import useRights from "@/shared/api/useRights";

export default function AddEvent({ onCreate }: { onCreate: (id: number) => void }) {
  const modalRef = useRef<any>(null);
  const [device, setDevice] = useState<any>(null);
  const [selectionOpen, setSelectionOpen] = useState(false);

  const region = usePersistantStore((x) => x.region);
  const rights = useRights();

  return (
    <Fragment>
      <LoadingButton
        onClick={() => {
          setDevice(null);
          setSelectionOpen(true);
        }}
        startIcon={<Add />}
      >
        Neuer Eintrag
      </LoadingButton>
      <Dialog fullWidth maxWidth="md" open={selectionOpen} onClose={() => setSelectionOpen(false)}>
        <DialogTitle>Gerät wählen</DialogTitle>
        <DialogContent>
          <ManyToOneSelect
            entity={"resource"}
            remoteFilter={{
              region: ["region", region],
            }}
            clearIcon={null}
            version="details"
            placeholder="Bitte wählen"
            currentId={device?.id || 0}
            disabled={false}
            sideEffectOnlyOnChange={true}
            setObject={setDevice}
            setId={(_t) => {}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectionOpen(false)}>Abbrechen</Button>
          <Button
            disabled={!device}
            onClick={() => {
              setSelectionOpen(false);
              modalRef.current?.openModal(null, "full");
            }}
            variant={"contained"}
          >
            Weiter
          </Button>
        </DialogActions>
      </Dialog>
      {!!device ? (
        <EventEditModal
          dateOnlyScheduling
          ApiService={ApiService}
          role={"SERVICE" in rights ? "service" : "site"}
          onCreate={onCreate}
          ref={modalRef}
          testingContent={
            device.testingContent || device.primaryResourceTag.testingContent
              ? (device.testingContent ?? []).concat(device.primaryResourceTag.testingContent ?? [])
              : null
          }
          lastReading={device.lastMeterReading?.runningHours || null}
          deviceId={device.id}
          deviceNumber={device.number}
        />
      ) : null}
    </Fragment>
  );
}
